export default {"src":"/_next/static/media/GPKG.65bd2465.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};